import React from 'react';
import CmsContentEditor from '../../../../components/cms/CmsContentEditor';

interface CmsContentPageProps {
  slug: string;
  title?: string;
  description?: string;
}

/** Thin route wrapper around the reusable CMS editor for a fixed slug. */
const CmsContentPage: React.FC<CmsContentPageProps> = ({ slug, title, description }) => (
  <div className="mx-auto max-w-5xl p-4 sm:p-6">
    <CmsContentEditor slug={slug} title={title} description={description} />
  </div>
);

export default CmsContentPage;
